import {Avatar, Badge, Col, Dropdown, Layout, Menu, Space} from "antd";
import {BellOutlined, DeleteOutlined, UserOutlined} from "@ant-design/icons";
import {useNavigate, useParams} from "react-router-dom";
import logo from "./logo.jpg"
import {AuthService} from "../../../services/Auth.service";
import React, {useEffect, useState} from "react";
import {UtilsService} from "../../../services/Utils.service";
import {AlertStatus, RoutingURL, StatusCodeE} from "../../../model/models";
import {HttpService} from "../../../services/http/Http.service";
import {EnvService} from "../../../services/Env.service";
import {SquareTile} from "../../home/squareTile/SquareTile";

const { Header } = Layout;



export default function HeaderLayout() {
    const { id, status } = useParams<{ id: string; status: string }>(); // Ensure correct type
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [alertCount, setAlertCount] = useState<number>(0);

    useEffect(() => {
        const fetchUsername = async () => {
            const data = await AuthService.getUsername();
            if (data) {
                setUsername(data.nome + " " + data.cognome);
            }
        };
        const fetchAlertCount = async () => {
            try {
                const res = await HttpService.getInstanceAxios().get(`/alert/non-payment/count/${AlertStatus.CREATO}`);
                setAlertCount(res.data);
            } catch (e) {
                console.error("Error fetching alert count", e);
            }
        };

        fetchUsername();
        fetchAlertCount();
    }, []);

    const menuItems = [
        { key: StatusCodeE.DA_LAVORARE, label: "Da Lavorare" },
        { key: StatusCodeE.IN_LAVORAZIONE, label: "In Lavorazione" },
        { key: StatusCodeE.DA_FIRMARE, label: "Da Firmare e Protocollare" },
        { key: StatusCodeE.NOTIFICA, label: "Notifica" },
        { key: StatusCodeE.ATTESA_PAGAMENTO, label: "Attesa Pagamento" }
    ];

    const handleMenuClick = (e: any) => {
        if(id != null && status != null) {
            let url: string = UtilsService.replaceId(RoutingURL.PRACTICES, id.toString());
            url = UtilsService.replaceStatus(url, e.key);
            navigate(url);
        } else {
            console.error("Can not go to requested page.")
        }
    };

    function onLogout() {
        AuthService.logout();
        navigate(RoutingURL.LOGIN);
    }

    const goToAlerts = () => {
        navigate(RoutingURL.AVVISO)
    };

    const goToProfile = () => {
        navigate(RoutingURL.PROFILE)
    };


    return (
        <Header style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 20px" }}>
            {/* Left - Logo */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <img src={logo} alt="Logo" style={{ height: "50px" }} />
            </div>

            {EnvService.isTestEnvironment() && (
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    TEST
                </div>
            )}

            {id != null && status != null && (
                <Menu
                    mode="horizontal"
                    items={menuItems}
                    selectedKeys={[status]}
                    onClick={handleMenuClick}
                    style={{ flex: 1, justifyContent: "center", borderBottom: "none" }}
                />
            )}


            <div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
                <div style={{cursor: "pointer"}} onClick={goToAlerts}>
                    <Badge count={alertCount} size="small" offset={[-5, 5]} color="#007a33">
                        <BellOutlined style={{ fontSize: 20, color: "white"}} />
                    </Badge>
                </div>

                <Dropdown
                    menu={{
                        items: [
                            { key: "profile", label: "Profilo", onClick: goToProfile },
                            { key: "logout", label: "Logout", onClick: onLogout },
                        ],
                    }}
                    placement="bottomRight"
                >
                    <Space>
                        <Avatar icon={<UserOutlined />} />
                        <span className={"custom-label-color"}>{username}</span>
                    </Space>
                </Dropdown>
            </div>
        </Header>


    );

}






/*
import {Header} from "antd/es/layout/layout";
import {Badge, Flex, Menu, MenuProps} from "antd";
import {BellFilled} from "@ant-design/icons";
import {useState} from "react";

export function HeaderLayout() {
    const [numberOfNotifies, setNumberOfNotifies] = useState<number>()

    const itemsMenu: MenuProps['items'] = [
/!*        {
            label: (<Badge count={numberOfNotifies} overflowCount={99}>
                <BellFilled style={getIconStyle()}/>
            </Badge>),
            key: 'notify',
            onClick: goToMessages
        },*!/
    ]

    function getIconStyle() {
        return {fontSize: '150%', color: "var(--secondary-color)"}
    }

/!*    function goToMessages() {
        navigate(AppRoutingURL.MESSAGES);
    }*!/

    return <>
        <Header style={{display: 'flex', alignItems: 'center'}}>
            <div className="logo"></div>
            <Menu
                theme="light"
                mode="horizontal"
                items={itemsMenu}
            >
            </Menu>
        </Header>
    </>
}*/
